import {computed, inject, Injectable, signal} from '@angular/core';
import {ShortcutContext} from '../../shortcuts/shortcut.context';

@Injectable({ providedIn: 'root' })
export class DialogFooterContext {
	private readonly shortcutsCtx = inject(ShortcutContext);

	readonly error = signal<string | null>(null);

	readonly shortcuts = this.shortcutsCtx.footerShortcuts;

	readonly visible = computed(() =>
		!!this.error() || this.shortcuts().length > 0
	);

	clearError() {
		this.error.set(null);
	}
}
